import { faMapLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DropDownButtons from "components/Ui/DropDownButtons/DropDownButtons";
import TableBodyCells from "components/Ui/TableBodyCells/TableBodyCells";

const City = (props) => {
    const cellRenderers = {
        id: () => <td>{props.region?.id}</td>,
        name: () => (
            <td className="name">
                <h6>{props.region?.name}</h6>
            </td>
        ),
        topic: () => <td>{props.region?.topic}</td>,
        phone: () => <td>{props.region?.phone || "لا يوجد"}</td>,
        location: () => (
            <td>
                {props.region?.location ? (
                    <a href={props.region?.location} target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faMapLocationDot} size="xl" color="red" />
                    </a>
                ) : (
                    "لا يوجد"
                )}
            </td>
        ),
        actions: () => (
            <td>
                <DropDownButtons
                    region={props.region}
                    edit={() => {
                        props.setSelectedRegionValue(props.region);
                        props.toggleEditForm();
                    }}
                    delete={() => {
                        props.setSelectedRegionValue(props.region);
                        props.toggleDelete();
                    }}
                    // The wallet policy is not part of the city form: that form
                    // posts multipart through the generic mass-assign PATCH,
                    // which the API closes to these columns. See CityWallet.
                    walletSettings={() => {
                        props.setSelectedRegionValue(props.region);
                        props.toggleWallet();
                    }}
                    // The restaurant wallet's master switch (api#147) — its own
                    // endpoint and its own modal, for the same reason.
                    vendorWalletSettings={() => {
                        props.setSelectedRegionValue(props.region);
                        props.toggleVendorWallet();
                    }}
                    // The free delivery rules of a city are delivery offers:
                    // this opens the offers page for the city. Not there for
                    // an admin with no permission for the offers.
                    freeDeliverySettings={
                        props.openDeliveryOffers
                            ? () => props.openDeliveryOffers(props.region)
                            : undefined
                    }
                    operationalSettings={() => {
                        props.setSelectedRegionValue(props.region);
                        props.toggleOperationalSettings();
                    }}
                ></DropDownButtons>
            </td>
        ),
    };

    return (
        <tr className="item">
            <TableBodyCells visibleColumns={props.visibleColumns} renderers={cellRenderers} />
        </tr>
    );
};

export default City;
